import { amplifySignOut } from '@/utils/auth';
import { fetchAuthSession } from 'aws-amplify/auth';
import router from '@/router';

export async function getSdkCredentials() {
  const session = await fetchAuthSession().catch(async () => {
    await amplifySignOut();
    await router.push('/login');
  });
  const sdkCredentials = {
    accessKeyId: session.credentials.accessKeyId,
    secretAccessKey: session.credentials.secretAccessKey,
    sessionToken: session.credentials.sessionToken,
    expiration: session.credentials.expiration,
  };
  return sdkCredentials;
}
